import React from "react";
// import ExecutiveCoachingbanner from "../../AVHRBanner/ExecutiveHiringtetwoNB.png";
// import ExecutiveCoachingbanner from "../../AVHRBanner/Performance_Management_Banner.png";
import { FaCheckCircle } from "react-icons/fa";
import ExecutiveCoachingOne from "../../Images/ExecutiveCoachingOneimg.png";
import ExecutiveCoachingbanner from "../../AVHRBanner/CareerTransitionSelected.png";
import "../OurServicesCss/Services.css";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";

function ExecutiveCoaching() {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };


  return (
    <>
      <div style={{ paddingTop: "100px" }}>
        <div className="relative w-full h-[400px] sm:h-[500px] md:h-[600px] lg:h-[700px] xl:h-[800px] banner">
          <img
            src={ExecutiveCoachingbanner}
            className="absolute inset-0 w-full h-full object-cover"
            alt=""
          />

          {/* Centered Content */}
          <div className="relative z-10 flex items-center justify-center h-full px-4 text-adjest">
            <div className="text-bannar max-w-3xl text-left avhrProject-bannerTextColour">
              <p className="edu-support-text uppercase">Our Services</p>

              <h1 className="career-library-heading">Career Transition</h1>

              {/* <p className="mt-4 leading-relaxed">
                
              </p> */}
            </div>
          </div>
        </div>

        <div className="w-full px-4 py-4 sm:px-6 md:px-10 lg:px-16">
          <div
            className="rounded-lg text-center p-2 sm:p-2 md:p-6 lg:p-2 shadow-md HeadingTagLine"
            style={{
              boxShadow: "0 6px 12px rgba(0, 0, 0, 0.25)",
            }}>
            <h1 className="mb-2 avhrProject-h1">
              Navigate Career Changes with Confidence
            </h1>
            <p className="avhrProject-p ml-4 mr-4" style={{ fontSize: "20px" }}>
              Whether you're changing industries or redefining your career goals, our
               Career Transitioning program is designed to guide you every step of the way.
                With expert coaching, we help you align with your inner core to pursue your dream role
            </p>
          </div>
        </div>



        <div
          className="py-10 px-4 sm:px-6 lg:px-20 carrerbackgroundcolour pt-2"
          style={{ backgroundColor: "#F8F6E3" }}>
          <h2 className="text-center mb-2 avhrProject-h2">Areas We Cover</h2>

          <div className="grid">
            <div className="col-12 grid">
              {/* Box 1 */}
              <div className="col-12 lg:col-6 flex align-items-start gap-3 mb-1">
                <span className="text-5xl mt-4">🚀</span>
                <div>
                  <h3 className=" mb-2 avhrProject-h3">Role Enhancement</h3>
                  <p className="avhrProject-p">
                    We help professionals upskill, take on leadership
                    responsibilities, and transition into more impactful roles
                    within their current organizations
                  </p>
                </div>
              </div>

              {/* Box 2 */}
              <div className="col-12 lg:col-6 flex align-items-start gap-3 mb-1">
                <span className="text-5xl mt-4">🔄</span>
                <div>
                  <h3 className=" mb-2 avhrProject-h3">Change in Industry</h3>
                  <p className="avhrProject-p">
                    For those looking to switch industries, we provide strategic
                    guidance, skill mapping, and mentorship to ensure a smooth
                    and successful transition
                  </p>
                </div>
              </div>

              {/* Box 3 */}
              <div className="col-12 lg:col-6 flex align-items-start gap-3 mb-1">
                <span className="text-5xl mt-4">🧭</span>
                <div>
                  <h3 className=" mb-2 avhrProject-h3">
                    Complete Career Shift
                  </h3>
                  <p className="avhrProject-p">
                    Whether due to passion, burnout, or new aspirations, we
                    support complete career overhauls with personalized
                    planning, training pathways, and ongoing support
                  </p>
                </div>
              </div>

              {/* Box 4 */}
              <div className="col-12 lg:col-6 flex align-items-start gap-3 mb-1">
                <span className="text-5xl mt-4">📈</span>
                <div>
                  <h3 className=" mb-2 avhrProject-h3">
                    Strategic Lateral Moves
                  </h3>
                  <p className="avhrProject-p">
                    Not all growth is upward — sometimes, a lateral move can
                    open new doors. We assist in identifying such opportunities
                    that align with long-term goals
                  </p>
                </div>
              </div>

              {/* Box 5 */}
              <div className="col-12 lg:col-6 flex align-items-start gap-3 mb-1">
                <span className="text-5xl mt-4">🌿</span>
                <div>
                  <h3 className=" mb-2 avhrProject-h3">Career Downshift</h3>
                  <p className="avhrProject-p">
                    Professionals seeking a less demanding role for work-life
                    integration, health, or personal reasons receive thoughtful
                    counsel and viable alternatives through our services
                  </p>
                </div>
              </div>

              {/* Box 6 */}
              <div className="col-12 lg:col-6 flex align-items-start gap-3 mb-1">
                <span className="text-5xl mt-4">💡</span>
                <div>
                  <h3 className=" mb-2 avhrProject-h3 ">
                    Transforming Failure to Success
                  </h3>
                  <p className="avhrProject-p">
                    We empower individuals to learn from setbacks and failures,
                    providing coaching and tools to rebuild confidence and chart
                    a new, successful career path
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full px-4 py-4 sm:px-6 md:px-10 lg:px-16">
          <Card
            className="CARDCOLOUR m-3"
            style={{
              background: "linear-gradient(-120deg, #FFDE89, #D64B52)",
            }}>
            <p className="mb-2 text-center avhrProject-p">Get Started</p>
            <h2 className="mt-2 text-center avhrProject-h2">
              Your new beginning starts here
            </h2>

            <div className="flex justify-content-center">
              <Button
                label="Contact Us"
                rounded
                onClick={() => handleNavigate("/contactus")}
                className="buttonAvhrProject"
              />
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}

export default ExecutiveCoaching;
